import {SaveProductTypeGuidRequest} from '../models/ProductTypes/IProductTypeGuid';
import {GuidLightDto} from '../models/common/IGuidLight';

interface ProductTypeGuidDraft {
    id?: string;
    name: string;
    recipes: GuidLightDto[];
    packages: GuidLightDto[];
    priceTiers: Array<{id?: string; fromValue: number; price: number}>;
}

export const toSaveProductTypeGuidRequest = (
    productType: ProductTypeGuidDraft,
    includeId: boolean,
): SaveProductTypeGuidRequest => ({
    ...(includeId && productType.id ? {id: productType.id} : {}),
    name: productType.name.trim(),
    recipes: productType.recipes.map(({id}) => ({id})),
    packages: productType.packages.map(({id}) => ({id})),
    priceTiers: productType.priceTiers.map(({id, fromValue, price}) => ({
        ...(includeId && id ? {id} : {}),
        fromValue,
        price,
    })),
});
